import groq from 'groq';

import { ASSET } from './asset';
import { BAR_CHART } from './barChart';
import { RICH_TEXT } from './richText';

const RICH_TEXT_WITH_IMAGE = groq`
  _type == 'block' => { ${RICH_TEXT} },
  _type == 'timeline_altImage' => { ${ASSET} },
  _type == 'chart' => {
    _type,
    _key,
    chart,
    "chartImage": chartImage.lightMode { ${ASSET} },
    barChart { ${BAR_CHART} }
  }
`;

export const STUDY_MODAL = groq`
  _type,
  overline {
    studyType,
    researchArea
  },
  title,
  studyDesign,
  description[] {
    ${RICH_TEXT}
  },
  studyRef -> {
    publishedDetails {
      publishedDate,
      journalLogo { ${ASSET} },
      citation { title, href },
      publicationLink,
    }
  },
  methods[] {
    body[] {
      ${RICH_TEXT_WITH_IMAGE}
    },
    characteristics[] {
      title,
      description
    }
  },
  results[] {
    ${RICH_TEXT_WITH_IMAGE}
  },
`;
